import React, { createContext } from 'react'
import { IAuthContext, IGetDataUser } from '@interfaces/index'

export type AuthContextType = {
    logout: () => void
    logIn: (data: IAuthContext) => void
    isAuthenticated: () => boolean
    getUserInfo: () => IGetDataUser | null
    getAccessToken: () => string | null
    getRefreshToken: () => string | null
    setDataUser: (dataUser: IGetDataUser) => void
}

export const AuthContext = createContext<AuthContextType | null>(null)

const AuthProvider = ({ children }: { children: React.ReactNode | React.ReactNode[] }): React.ReactElement => {
    function logIn(res: IAuthContext): void {
        localStorage.setItem('userData', JSON.stringify(res.user))
        localStorage.setItem('accessToken', res.accessToken)
        localStorage.setItem('refreshToken', res.refreshToken)
    }

    function isAuthenticated(): boolean {
        return localStorage.getItem('accessToken') !== null
    }

    function logout(): void {
        localStorage.clear()
    }

    function getUserInfo(): IGetDataUser | null {
        const data = localStorage.getItem('userData')
        if (data) {
            return JSON.parse(data)
        }
        return null
    }

    function getAccessToken(): string | null {
        return localStorage.getItem('accessToken')
    }

    function setDataUser(dataUser: IGetDataUser): void {
        const accessToken = localStorage.getItem('accessToken')
        if (accessToken && dataUser !== getUserInfo()) {
            const dataUserJSON = JSON.stringify(dataUser)
            localStorage.setItem('userData', dataUserJSON)
        }
    }

    function getRefreshToken(): string | null {
        return localStorage.getItem('refreshToken')
    }

    return (
        <AuthContext.Provider value={{ logIn, isAuthenticated, logout, getUserInfo, getAccessToken, getRefreshToken, setDataUser }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider
